export const HIT_READY_EVENT = 'aedu:hit-ready';

export function announceHitReady(): void {
  window.dispatchEvent(new Event(HIT_READY_EVENT));
}
